/**
 * VyV Conseil MRH Public API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpUrlEncodingCodec } from '@angular/common/http';

import { Observable } from 'rxjs';

import { VyVContextId } from '../models/vyVContextId';
import { VyVContractCheckIBANRequest } from '../models/vyVContractCheckIBANRequest';
import { VyVContractCheckIBANResponse } from '../models/vyVContractCheckIBANResponse';
import { VyVContractCreateRequest } from '../models/vyVContractCreateRequest';
import { VyVContractCreateResponse } from '../models/vyVContractCreateResponse';
import { VyVContractDocumentType } from '../models/vyVContractDocumentType';
import { VyVContractId } from '../models/vyVContractId';
import { VyVSharedProblemDetails } from '../models/vyVSharedProblemDetails';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { AppConfig } from 'src/app/app.config';

@Injectable()
export class ContractService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders({
    'x-brand': this.appConfig.getConfig('brand')
  });
  public configuration = new Configuration();

  constructor(
    @Inject(AppConfig) private appConfig: AppConfig,
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   * Verify bank account eligibility
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public checkIBAN(
    body?: VyVContractCheckIBANRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VyVContractCheckIBANResponse>;
  public checkIBAN(
    body?: VyVContractCheckIBANRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VyVContractCheckIBANResponse>>;
  public checkIBAN(
    body?: VyVContractCheckIBANRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VyVContractCheckIBANResponse>>;
  public checkIBAN(
    body?: VyVContractCheckIBANRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json', 'application/problem+json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<VyVContractCheckIBANResponse>(
      'post',
      `${this.basePath}/api/contract/1`,
      {
        body: body,
        withCredentials: true,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Create new contract request
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createContract(
    body?: VyVContractCreateRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VyVContractCreateResponse>;
  public createContract(
    body?: VyVContractCreateRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VyVContractCreateResponse>>;
  public createContract(
    body?: VyVContractCreateRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VyVContractCreateResponse>>;
  public createContract(
    body?: VyVContractCreateRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json', 'application/problem+json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<VyVContractCreateResponse>(
      'post',
      `${this.basePath}/api/contract/2`,
      {
        body: body,
        withCredentials: true,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Fetch contract document
   * @param id
   * @param type
   * @param context
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getContractDocumentById(
    id: VyVContractId,
    type: VyVContractDocumentType,
    context: VyVContextId,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public getContractDocumentById(
    id: VyVContractId,
    type: VyVContractDocumentType,
    context: VyVContextId,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public getContractDocumentById(
    id: VyVContractId,
    type: VyVContractDocumentType,
    context: VyVContextId,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public getContractDocumentById(
    id: VyVContractId,
    type: VyVContractDocumentType,
    context: VyVContextId,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling getContractDocumentById.'
      );
    }

    if (type === null || type === undefined) {
      throw new Error(
        'Required parameter type was null or undefined when calling getContractDocumentById.'
      );
    }

    if (context === null || context === undefined) {
      throw new Error(
        'Required parameter context was null or undefined when calling getContractDocumentById.'
      );
    }

    let queryParameters = new HttpParams({ encoder: new HttpUrlEncodingCodec() });
    if (context !== undefined && context !== null) {
      queryParameters = queryParameters.set('context', <any>context);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/octet-stream', 'application/problem+json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<any>(
      'get',
      `${this.basePath}/api/contract/${encodeURIComponent(
        String(id)
      )}/documents/${encodeURIComponent(String(type))}`,
      {
        params: queryParameters,
        withCredentials: true,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}
